import React from "react";
import CloseButton from "../../Reutilizaveis/CloseButton";
import { ReactComponent as ErrorIcon } from "../../../assets/novosicones/Financeiro/error_black_24dp.svg";
const ErrorMsg = ({ setSolicitacaoInvalida }) => {
  return (
    <div
      className="centralized"
      style={{
        position: "fixed",
        top: "0px",
        left: "0",
        height: "100%",
        width: "100%",
        backgroundColor: "rgb(255, 255, 255)",
        background:
          "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(77,77,77,0.499019676229867) 40%, rgba(45,45,45,1) 100%)",
        zIndex: "9999999999999999999999999999999999",
        alignItems: "flex-start",
        paddingTop: "50px",
      }}
    >
      <div className="container">
        <div
          style={{
            height: "100px",
            width: "calc(100% - 100px)",
            backgroundColor: "#ffffff",
            borderRadius: "22px",
            opacity: "1",
            zIndex: "99999999999999999999999999999999999",
            position: "relative",
            padding: "0 50px",
          }}
          className="centralized"
        >
          <ErrorIcon />
          <div
            className="centralized-column-flex-start"
            style={{ marginLeft: "15px" }}
          >
            <span
              style={{ fontSize: "18px", color: "#4D4D4D", fontWeight: "900" }}
            >
              Solicitação inválida
            </span>
            <p style={{ width: "80%", margin: "0", fontSize: "14px" }}>
              No momento o servidor não pode ou não irá processar a requisição,
              tente novamente ou entre em contato com nossa central de
              relacionamento para mais informações.
            </p>
          </div>

          <span
            onClick={() => {
              setSolicitacaoInvalida(false);
            }}
            style={{
              position: "absolute",
              right: "-20px",
              top: "calc(50% - 15px)",
              cursor: "pointer",
            }}
          >
            <CloseButton
              tamanho={"30px"}
              tamanhoIcone={"15px"}
              corBackground={"#ffffff"}
            />
          </span>
        </div>
      </div>
    </div>
  );
};

export default ErrorMsg;
